import { z } from "zod";
import { HULL_IDS, MODULE_IDS, WEAPON_IDS } from "./definitions.js";
import { PASSIVE_IDS } from "./contracts.js";

export const FRAME_PRICE_VERSION = "frames-20261027-v1";
export const hullTierSchema = z.union([z.literal(1), z.literal(2), z.literal(3)]);
export type HullTier = z.infer<typeof hullTierSchema>;
const mk = z.union([z.literal(0), z.literal(1), z.literal(2)]);
export const frameFittingSchema = z.strictObject({
  tier: hullTierSchema,
  weapons: z.array(z.strictObject({ id: z.enum(WEAPON_IDS), tier: mk })).max(2),
  module: z.strictObject({ id: z.enum(MODULE_IDS), tier: mk }).nullable(),
  passive: z.strictObject({ id: z.enum(PASSIVE_IDS).exclude(["none"]), tier: mk }).nullable(),
  reactor: mk.nullable(),
});
export type FrameFitting = z.infer<typeof frameFittingSchema>;
export function baseFrameFitting(): FrameFitting { return { tier: 1, weapons: [], module: null, passive: null, reactor: null }; }
export const FRAME_RULES = {
  1: { weapons: 1, active: 2, passive: 1, damage: 1, durability: 1 },
  2: { weapons: 2, active: 2, passive: 2, damage: 1.15, durability: 1.12 },
  3: { weapons: 3, active: 3, passive: 2, damage: 1.35, durability: 1.2 },
} as const;
export const REACTORS = [
  { name: "Реактор I", regeneration: 1.2, credits: "10000", components: 300 },
  { name: "Реактор II", regeneration: 1.35, credits: "80000", components: 2400 },
  { name: "Реактор III", regeneration: 1.5, credits: "600000", components: 18000 },
] as const;
export function frameCost(tier: HullTier) { return tier === 2 ? { credits: "300000", components: 9000 } : { credits: "5000000", components: 150000 }; }
export const framePurchaseInputSchema = z.strictObject({ requestId: z.string().min(8).max(100), hullId: z.enum(HULL_IDS), tier: hullTierSchema, priceVersion: z.string().min(1).max(100) });
export const frameInstallInputSchema = z.strictObject({ requestId: z.string().min(8).max(100), hullId: z.enum(HULL_IDS), fitting: frameFittingSchema });
export const reactorPurchaseInputSchema = z.strictObject({ requestId: z.string().min(8).max(100), tier: mk, priceVersion: z.string().min(1).max(100) });
export const frameProfileSchema = z.strictObject({
  fitting: frameFittingSchema,
  owned: z.array(z.strictObject({ hullId: z.enum(HULL_IDS), tier: hullTierSchema })).max(15),
  reactors: z.array(mk).max(3), priceVersion: z.string().min(1).max(100),
});
export type FrameProfile = z.infer<typeof frameProfileSchema>;
